"use strict";

exports.__esModule = true;
exports.default = void 0;
var _cookie = require("@tajawal/web-core-sdk-v2/lib/services/cookie.service");
var _auth = require("../clients/auth.client");
var _constants = require("../constants");
var _auth2 = require("../utils/auth.utils");
const authServerInterceptor = {
  /**
   * request auth interceptor
   *
   * @param {object} _config [request config]
   * @return {object} config [request config]
   */
  async request(ctx) {
    return _config => {
      let config = _config;
      if (config.url.includes('/myaccount/')) {
        const apiToken = (0, _auth2.getCookie)(ctx, _constants.STORAGE_KEYS.ENIGMA_API_TOKEN);
        config = apiToken ? {
          ...config,
          headers: {
            ...config.headers,
            'x-authorization': apiToken
          }
        } : config;
      }
      const token = (0, _auth2.getCookie)(ctx, _constants.STORAGE_KEYS.AUTH_TOKEN);
      return token ? {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`
        }
      } : config;
    };
  }
};
var _default = authServerInterceptor;
exports.default = _default;